exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hint-text[data-v-3926c6a1]{margin-bottom:0}.driver-card[data-v-3926c6a1]{max-width:1240px;padding:0 30px 50px;border-bottom:1px solid #cecece}.driver-card__controls[data-v-3926c6a1]{padding-top:0}.driver-card__action-link[data-v-3926c6a1]{cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:6px;text-decoration:none;color:inherit}.driver-card__icon[data-v-3926c6a1]{width:21px;height:21px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3926c6a1","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/change/components/DriverCard.vue
// module id = +gCU
// module chunks = 0